import { CommonMessages } from 'src/messages/validationMessages';
import { EMAIL_REGEX } from 'src/utils/constants';
import * as Yup from 'yup';

export const MyprofileSchema = Yup.object().shape({
    FullName: Yup.string().required(CommonMessages.name_required),
    Email: Yup.string()
        .matches(EMAIL_REGEX, CommonMessages.email_invalid)
        .required(CommonMessages.email_required),
});